import { BuildInfoService } from '../lib/buildInfo';
import { formatTimeAgo } from '../lib/timeAgo';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const buildInfo = BuildInfoService.getDisplayInfo();
  const deployedAgo = buildInfo ? formatTimeAgo(buildInfo.deploymentTime) : null;

  return (
    <footer className="bg-dark-blue text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Pairing.dev</h3>
            <p className="text-sm text-gray-300">
              Technical Team Extension for Your Startup (incl. CTO)
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>
                <span className="font-medium">Location:</span><br />
                Pairing OÜ<br />
                Sakala 7-2, 10141 Tallinn
              </p>
              <p>
                <span className="font-medium">Email:</span><br />
                <a href="mailto:info@pairing.dev" className="hover:text-white transition-colors">
                  info@pairing.dev
                </a>
              </p>
              <p>
                <span className="font-medium">Phone:</span><br />
                <a href="tel:+19292601944" className="hover:text-white transition-colors">
                  +1 929 260 1944
                </a>
              </p>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <div className="space-y-2 text-sm">
              <a href="/" className="block text-gray-300 hover:text-white transition-colors">
                Home
              </a>
              <a href="/casestudies" className="block text-gray-300 hover:text-white transition-colors">
                Case Studies
              </a>
              <a href="/about" className="block text-gray-300 hover:text-white transition-colors">
                About
              </a>
              <a href="/blog" className="block text-gray-300 hover:text-white transition-colors">
                Blog
              </a>
              <a href="/book" className="block text-gray-300 hover:text-white transition-colors">
                Get a Price
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <p className="text-sm text-gray-300">
                © {currentYear} Pairing.dev. All rights reserved.
              </p>
            </div>

            {buildInfo && deployedAgo && (
              <div className="flex items-center gap-2">
                <span
                  className="font-mono text-xs text-gray-400 cursor-pointer hover:text-white transition-colors"
                  title={`${buildInfo.message} by ${buildInfo.author}`}
                >
                  {buildInfo.version}
                </span>
                <span className="text-xs text-gray-500">•</span>
                <span className="text-xs text-gray-400">
                  deployed {deployedAgo}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
